<script setup>
import { computed, onMounted } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';

import NativeSelect from 'dashboard/components-next/native-select/NativeSelect.vue';

const props = defineProps({
  contact: {
    type: Object,
    default: () => ({}),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update']);

const store = useStore();
const getters = useStoreGetters();

const stages = computed(() => getters['lifecycleStages/getStages'].value);
const settings = computed(() => getters['lifecycleStages/getSettings'].value);
const selectedStageId = computed(() => {
  return (
    props.contact.lifecycleStageId || props.contact.lifecycle_stage_id || ''
  );
});
const isVisible = computed(
  () => settings.value.enabled !== false && stages.value.length
);

const selectModelValue = computed({
  get() {
    const id = selectedStageId.value;
    return id === '' || id === null ? '' : id;
  },
  set(val) {
    emit('update', val !== '' && val != null ? Number(val) : null);
  },
});

onMounted(() => {
  if (!stages.value.length) {
    store.dispatch('lifecycleStages/get');
  }
});
</script>

<template>
  <div>
    <label
      v-if="isVisible"
      class="flex flex-col w-full gap-1 text-sm text-n-slate-11"
    >
      <span class="font-medium text-n-slate-12">
        {{ $t('LIFECYCLE_STAGES.CONTACT_FIELD.LABEL') }}
      </span>
      <NativeSelect v-model="selectModelValue" :disabled="disabled">
        <option value="">
          {{ $t('LIFECYCLE_STAGES.CONTACT_FIELD.NO_STAGE') }}
        </option>
        <option v-for="stage in stages" :key="stage.id" :value="stage.id">
          {{ stage.icon }} {{ stage.name }}
        </option>
      </NativeSelect>
    </label>
  </div>
</template>
